/**
 * Referred from https://github.com/shoelace-style/shoelace/blob/next/src/internal/slot.ts
 */
export class SlotController {
    static { this.default = '[default]'; }
    constructor(host, ...slotNames) {
        this.handleSlotChange = (event) => {
            const slot = event.target;
            const normalizedSlotName = slot.name || SlotController.default;
            if (this.slotNames.includes(normalizedSlotName)) {
                this.host.requestUpdate();
            }
        };
        this.host = host;
        // Normalize null values to track the default slot
        this.slotNames = slotNames.length ? slotNames.map((slot) => slot ?? SlotController.default) : [SlotController.default];
        this.host.addController(this);
    }
    hasDefaultSlot() {
        return Array.from(this.host.childNodes).some((node) => {
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
                return true;
            }
            if (node.nodeType === Node.ELEMENT_NODE) {
                const el = node;
                // Elements without a slot attribute belong to the default slot
                if (!el.hasAttribute('slot')) {
                    return true;
                }
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
    /**
     * Checks if a given slot has content.
     */
    hasSlotted(slotName = SlotController.default) {
        const normalizedSlot = slotName ?? SlotController.default;
        return normalizedSlot === SlotController.default ? this.hasDefaultSlot() : this.hasNamedSlot(normalizedSlot);
    }
    /**
     * Checks if all requested slots are empty.
     */
    isEmpty(...names) {
        return !this.hasSlotted(...names);
    }
    /**
     * Retrieves the elements assigned to a given slot.
     */
    getSlotted(slotName = SlotController.default) {
        const normalizedSlot = slotName ?? SlotController.default;
        return normalizedSlot === SlotController.default
            ? Array.from(this.host.children).filter((el) => !el.hasAttribute('slot'))
            : Array.from(this.host.querySelectorAll(`:scope > [slot="${normalizedSlot}"]`));
    }
    hostConnected() {
        this.host.shadowRoot?.addEventListener('slotchange', this.handleSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot?.removeEventListener('slotchange', this.handleSlotChange);
    }
}
